// A task's full page (pages/work/TaskPage): the ONE place the URL is built. The Work page, the site and
// initiative task lists and the retired /work/tasks/:taskId/details redirect all use it.
export const taskPagePath = (recordId: string) => `/work/task/${recordId}`
